// eslint-disable-next-line no-restricted-imports
import { TableCell, styled } from '@mui/material';
import { ReactNode } from 'react';

export type CellProps = {
  children: ReactNode;
};

const StyledTableCell = styled(TableCell)({
  borderBottom: 'none',
  fontSize: 14,
  '&:first-child': {
    paddingLeft: 0,
  },
  '&:last-child': {
    paddingRight: 0,
  },
});

export const Cell = ({ children }: CellProps) => {
  return <StyledTableCell>{children}</StyledTableCell>;
};
